import { FC } from 'react'
import { RenderIf } from '../../../../components/RenderIf'
import { ClickCollectNotificationsModal } from './clickCollectNotifications'
import { CallWaiterModal } from '../CallWaiterModal'

type NotificationsModalProps = {
  onDeclineClose: () => void
  onSuccessClose: () => void
}

export const NotificationsModal: FC<NotificationsModalProps> = ({
  onDeclineClose,
  onSuccessClose,
}) => {
  return (
    <>
      <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
        <CallWaiterModal
          onDeclineClose={onDeclineClose}
          onSuccessClose={onSuccessClose}
        />
      </RenderIf>
      <RenderIf condition={process.env.REACT_APP_IS_CLIC === '1'}>
        <ClickCollectNotificationsModal />
      </RenderIf>
    </>
  )
}
